export default __webpack_public_path__ + "685b485d826f146fd3e9452de41c83ab.png";